$( window ).on( "load", function (){
	if ($("html").attr("data-bank") == "PBZ") {
		if($(".-js-bookAnAppointmentCalendar").length > 0){
			$(".datepicker-grid").find("td.curDay").click();			
		}
	}
});
